import { ChartSkeleton, classNames, Flex } from "@opensea/ui-kit"
import type { ComponentPropsWithoutRef } from "react"

type TimeSeriesChartSkeletonProps = ComponentPropsWithoutRef<
  typeof ChartSkeleton
>

type CurrencyTimeSeriesChartSkeletonProps<T> = {
  className?: string
} & Partial<T>

export function CurrencyTimeSeriesChartSkeleton({
  className,
  ...rest
}: CurrencyTimeSeriesChartSkeletonProps<TimeSeriesChartSkeletonProps>) {
  return (
    <Flex className={classNames("h-[400px] md:h-[450px]", className)}>
      <ChartSkeleton className="size-full" {...rest} />
    </Flex>
  )
}
